import { VariantsStyle } from "./banner.type";

const variants: VariantsStyle = {
  info: {
    backgroundColor: "banner-informative-background-color",
    borderColor: "banner-informative-color",
    titleColor: "text-color",
    textColor: "informative-text-color",
    actionsColor: "informative-text-color",
    iconColor: "banner-informative-color",
    iconName: "info-circle",
    weight: "solid",
  },
  warning: {
    backgroundColor: "banner-warning-background-color",
    borderColor: "warning-text-color",
    titleColor: "text-color",
    textColor: "informative-text-color",
    actionsColor: "informative-text-color",
    iconColor: "warning-text-color",
    iconName: "exclamation-triangle",
    weight: "solid",
  },
  success: {
    backgroundColor: "banner-positive-background-color",
    borderColor: "positive-text-color",
    titleColor: "text-color",
    textColor: "informative-text-color",
    actionsColor: "informative-text-color",
    iconColor: "positive-text-color",
    iconName: "check-circle",
    weight: "solid",
  },
  error: {
    backgroundColor: "banner-negative-background-color",
    borderColor: "negative-text-color",
    titleColor: "text-color",
    textColor: "informative-text-color",
    actionsColor: "informative-text-color",
    iconColor: "negative-text-color",
    iconName: "exclamation-circle",
    weight: "solid",
  },
};

export default variants;
